import i18n, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './langs/en-US.json';
import jaJP from './langs/ja-JP.json';
import zhCN from './langs/zh-CN.json';

export const supportedLanguages = ['zh-CN', 'en-US', 'ja-JP'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const LANGUAGE_STORAGE_KEY = 'japandx.language';

const languageMap: Record<string, SupportedLanguage> = {
  zh: 'zh-CN',
  'zh-CN': 'zh-CN',
  en: 'en-US',
  'en-US': 'en-US',
  'en-GB': 'en-US',
  ja: 'ja-JP',
  'ja-JP': 'ja-JP',
};

function getBrowserLanguage(): SupportedLanguage {
  const browserLanguage = navigator.language;
  return languageMap[browserLanguage] ?? languageMap[browserLanguage.split('-')[0]] ?? 'zh-CN';
}

function getInitialLanguage(): SupportedLanguage {
  const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return savedLanguage && supportedLanguages.includes(savedLanguage as SupportedLanguage)
    ? (savedLanguage as SupportedLanguage)
    : getBrowserLanguage();
}

use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
    'ja-JP': { translation: jaJP },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'zh-CN',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (language) => {
  const resolvedLanguage = languageMap[language] ?? 'zh-CN';
  localStorage.setItem(LANGUAGE_STORAGE_KEY, resolvedLanguage);
  document.documentElement.lang = resolvedLanguage;
});

document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;

export default i18n;
